import React from "react";

const MiniCategoryCard = ({ title, icon }) => {
  return (
    <div className="w-full sm:w-auto flex items-center p-4 gap-3 rounded-lg border border-gray-200 shadow-sm cursor-pointer transition-all duration-200 bg-white text-gray-600 hover:bg-gray-50">
      {icon && (
        <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
          {icon}
        </span>
      )}
      <span className="text-base font-medium truncate">{title}</span>
    </div>
  );
};

export default MiniCategoryCard;
